import { render, staticRenderFns } from "./Navgation.vue?vue&type=template&id=6531f94c&"
import script from "./Navgation.vue?vue&type=script&lang=ts&"
export * from "./Navgation.vue?vue&type=script&lang=ts&"
import style0 from "./Navgation.vue?vue&type=style&index=0&id=6531f94c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports